/**
 * App Redux Action Types
 */
export const COLLAPSED_SIDEBAR = 'COLLAPSED_SIDEBAR';
export const COLLAPSED_FIELD_SIDEBAR = 'COLLAPSED_FIELD_SIDEBAR';
export const COLLAPSED_NOTIFICATION_SIDEBAR = 'COLLAPSED_NOTIFICATION_SIDEBAR';
export const SHRINK_SIDEBAR = 'SHRINK_SIDEBAR';
export const TOGGLE_SIDEBAR_IMAGE = 'TOGGLE_SIDEBAR_IMAGE';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_PAGE_HISTORY = 'SET_PAGE_HISTORY';
export const REMOVE_PAGE_HISTORY = 'REMOVE_PAGE_HISTORY';
export const REFRESH_MATERIAL = 'REFRESH_MATERIAL';

// Config Data
export const SET_ADDRESS_LIST = 'SET_ADDRESS_LIST';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CONFIG_RECRUITMENT = 'SET_CONFIG_RECRUITMENT';
export const SET_ALL_FIELD_LIST = 'SET_ALL_FIELD_LIST';
export const SET_DEFAULT_FIELD = 'SET_DEFAULT_FIELD';

// Auth Actions
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const ME = 'ME';
export const LOGIN_LOADING = 'LOGIN_LOADING';
//crm
export const ADD_NEW_CLIENT = 'ADD_NEW_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
//loading
export const SET_LOADING = 'SET_LOADING';
export const SET_GET_LOADING = 'SET_GET_LOADING';
//scroll
export const SET_GO_SCROLL_TOP = 'SET_GO_SCROLL_TOP';

// Consult
export const SET_ORDER_SUPPORT_CONFIG = 'SET_ORDER_SUPPORT_CONFIG';
export const SET_ORDER_SUPPORT_CHECKLISTS = 'SET_ORDER_SUPPORT_CHECKLISTS';

export const SET_COMMON_POPUP = 'SET_COMMON_POPUP';
export const CLOSE_COMMON_POPUP = 'CLOSE_COMMON_POPUP';

export const SET_COMMON_DIALOG = 'SET_COMMON_DIALOG';
export const CLOSE_COMMON_DIALOG = 'CLOSE_COMMON_DIALOG';

// Noty
export const SET_NOTY_NEW_FIELD = 'SET_NOTY_NEW_FIELD';
export const SET_NOTY_NEW_MENU = 'SET_NOTY_NEW_MENU';
export const SET_NOTY_COUNT = 'SET_NOTY_COUNT';

// Floating Button
export const SET_MOVE_FLOATING_BUTTON = 'SET_MOVE_FLOATING_BUTTON';
